module.exports = __webpack_public_path__ + "static/media/banner-setting.d9d693f0.jpg";